import { render, staticRenderFns } from "./PFImage.vue?vue&type=template&id=54538b58&scoped=true&"
import script from "./PFImage.vue?vue&type=script&lang=js&"
export * from "./PFImage.vue?vue&type=script&lang=js&"
import style0 from "./PFImage.vue?vue&type=style&index=0&id=54538b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54538b58",
  null
  
)

export default component.exports